/**
 * 店鋪庫存管理系統 (Club Inventory) 權限金鑰 (FrontKey) 定義
 * 
 * 用於選單顯示控管及路由訪問權限。
 * 這些 Key 必須與後端資料庫中的權限定義一致。
 */
export const FRONT_KEY = Object.freeze({
    /** ▌店鋪庫存管理系統入口 **/
    INVENTORY: "D01X01",
    /** ▌庫存管理 **/
    STOCK: "D02X01",
    /** 庫存總覽 **/
    STOCK_OVERVIEW: "D02X02",
    /** 商品庫存明細 **/
    STOCK_DETAIL: "D02X03",
    /** ▌進出貨管理 **/
    PURCHASE: "D03X01",
    /** 進貨總覽 **/
    PURCHASE_OVERVIEW: "D03X02",
    /** 進貨單 **/
    PURCHASE_ORDER: "D03X03",
    /** 出貨總覽 **/
    SHIPMENT_OVERVIEW: "D03X04",
    /** 出貨單明細 **/
    SHIPMENT_DETAIL: "D03X05",
});
